export enum AgentApplicationCircuitState {
    Closed = 'closed',
    Open = 'open',
    HalfOpen = 'half_open',
}
